import React from 'react'


export default function ProjectList() {

  return (
    <>
    
      <div id="projects" className="bigger-container1">

      <p className="projects">Projects</p>

        <div className="projects-container">
             <div className="first-container">
          <div className="project1-bigger-container">
              <a href="https://secure-escarpment-53630.herokuapp.com/bd187e1f-7ff1-4f96-ba4f-3644f3a7d0d3" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/kWXHe7l.png" />
              <p className="first-project-name">Zoom Clone</p>
                  <p className="first-project-details">Web Version of Zoom Clone</p>

                </a>
            </div> 
            
            <div className="project2-bigger-container">
              <a href="https://intense-harbor-50663.herokuapp.com/" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/DwkHgeU.png" />
              <p className="first-project-name">React TypeScript Quiz App</p>
                  <p className="first-project-details">Quiz App Built with React and TypeScript</p>
                </a>
              </div> 
      </div>
          
        <div className="first-container">
          <div className="project1-bigger-container">
              <a href="https://netflix-clone-53735.web.app/" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/7tRkh1l.png" />
              <p className="first-project-name">Netflix Clone</p>
                  <p className="first-project-details">Full-Stack Netflix Clone</p>
                </a>
            </div> 
            
            <div className="project2-bigger-container">
              <a href="https://instagram-clone-react-998f2.web.app/" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/1j59pb6.png" />
              <p className="first-project-name">Instagram Clone</p>
                  <p className="first-project-details">Full-Stack E-commerce Build</p>
                </a>
              </div> 
      </div>
          
          
          <div className="first-container">
          <div className="project1-bigger-container">
              <a href="https://clone-36ae6.web.app" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/jJlv7Xx.png" />
              <p className="first-project-name">Google Clone</p>
                  <p className="first-project-details">Full-Stack Google Clone</p>
                </a>
            </div> 
            
            <div className="project2-bigger-container">
              <a href="https://clone-93db3.web.app/" target="blank">
              <img className="project1-container" alt="project1-name" src="https://i.imgur.com/J23bAmf.png" />
              <p className="first-project-name">Amazon Clone</p>
                  <p className="first-project-details">Full-Stack E-commerce Build</p>
                </a>
              </div> 
      </div>

          <div className="second-container">
            
          <div className="project3-bigger-container">
              <a href="https://jason-kang-bookreviews.netlify.app/" target="blank">
              <img className="project2-container" alt="project1-name" src="https://i.imgur.com/J40sgCr.png" />
              <p className="first-project-name">BookReviews</p>
                  <p className="first-project-details">Book Review Website</p>
                </a>
            </div> 
            
              <div className="project4-bigger-container">
              <a href="https://myalpaca.netlify.app/" target="blank">
                <img className="project3-container" alt="project3-name" src="https://i.imgur.com/YwazhEa.png" />
                <p className="third-project-name">myAlpaca</p>
                    <p className="third-project-details">International Student Resource Website</p>
                </a>
                <div/>
          </div>
            
          
       
          </div>


          <div className="third-container">

            <div className="project5-bigger-container">
            <a href="https://jason-kang-world-billionaires.netlify.app/" target="blank">
                <img className="project4-container" alt="project4-name" src="https://i.imgur.com/LJVwpR5.png" />
                <p className="second-project-name">World Billionaires</p>
                    <p className="third-project-details">The World's Billionaires Website</p>
                    </a>
              </div>
              
            <div className="project6-bigger-container">
              <a href="https://jason-kang-top-nba-players.netlify.app/" target="blank">
              <img className="project5-container" alt="project5-name" src="https://i.imgur.com/qMOHstP.png" />
              <p className="fourth-project-name">Top NBA Players</p>
                  <p className="fourth-project-details">NBA Players' GIFs and Statistics Website</p>
                  </a>
            </div>
            
            </div>
            

      </div>
      </div>
      
    </>
  )
}
